import React from 'react';
import { scriptInsert } from './Helpers'


function Nav() {
  
  scriptInsert('/assets/js/jquery.min.js'); 
  scriptInsert('/assets/js/browser.min.js');
  scriptInsert('/assets/js/breakpoints.min.js');
  scriptInsert('/assets/js/util.js');
  scriptInsert('/assets/js/main.js');
  scriptInsert('//cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.js');
  
  return (
    <nav id="menu">
    <ul className="links">
        <li><a href="/">Home</a></li>
        <li><a href="/privacy">Privacy Policy</a></li>
        <li><a href="/terms">Terms of Service</a></li>
        <li><a href="/cookie">Cookie Policy</a></li>
        <li><a href="/opt-out">Opt-Out Request</a></li>
    </ul>
    </nav>
  );
}

export default Nav;